import React from 'react'
import Layout from '../layout/Layout'
import SettingsSvg from '../other/svg/SettingsSvg'
import { useTranslation } from 'react-i18next'
import View from '../atoms/View'
import SelectInput from '../atoms/SelectInput'
import CountryFlag from '../atoms/CountryFlag'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
import { UPDATE_PROFILE } from 'dealer-reducers'

const LanguageSettings = (): JSX.Element => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const reducerLang = useSelector((state: RootReducer) => state.userDataReducer.default_language_code)
  const onChange = (val: string | number | boolean): void => {
    dispatch(UPDATE_PROFILE({ dealer: { default_language_code: val as string } }))
  }

  return (
    <Layout
      withoutToolbar={false}
      iconComponent={<SettingsSvg className="w-8 h-8 text-white" />}
      withFiler={false}
      name={t('set_language')}>
      <View className="">
        <View className="w-[300px] mt-2">
          <SelectInput
            value={reducerLang}
            options={[
              {
                optionVal: 'de',
                optionLabel: 'DE',
                optionIcon: () => <CountryFlag countryCode={'de'} />
              },
              {
                optionLabel: 'PL',
                optionVal: 'pl',
                optionIcon: () => <CountryFlag countryCode={'pl'} />
              },
              {
                optionLabel: 'EN',
                optionVal: 'en',
                optionIcon: () => <CountryFlag countryCode={'gb'} />
              },
              {
                optionLabel: 'RO',
                optionVal: 'ro',
                optionIcon: () => <CountryFlag countryCode={'ro'} />
              }
            ]}
            label={t('set_language')}
            onChange={onChange}
          />
        </View>
      </View>
    </Layout>
  )
}

export default LanguageSettings
